/*! @pentacode/ui v0.1.0 */
import { t as e } from "../../styledElement-Dm1irIE2.js";
import { t } from "../../decorateMetadata-BhwOl-pv.js";
import { t as n } from "../../decorate-DHgd5sZx.js";
import "../../icon-DGn-d_zv.js";
import { FormElement as r } from "../formElement.js";
import { InputLabel as i } from "./input-label.js";
import { LitElement as a, html as o, nothing as s } from "lit";
import { customElement as c, property as l, state as u } from "lit/decorators.js";
//#region src/elements/form-elements/select.ts
var d = class extends e(r(a)) {
	constructor(...e) {
		super(...e), this.options = [], this.placeholder = "-- Bitte wählen --", this.name = "", this.label = void 0, this.disabled = !1, this.required = !1, this.chevronStyle = "background", this.selectedOption = null;
	}
	createSelectChangeEvent(e) {
		return new CustomEvent("change", {
			detail: {
				value: e.value,
				option: e
			},
			bubbles: !0,
			composed: !0
		});
	}
	connectedCallback() {
		super.connectedCallback(), this.value && this.options.length > 0 && (this.selectedOption = this.options.find((e) => e.value === this.value) || null);
	}
	handleSelectChange(e) {
		let t = e.target.value, n = this.options.find((e) => e.value === t);
		n && !n.disabled && (this.selectedOption = n, this.value = n.value, this.dispatchEvent(this.createSelectChangeEvent(n)));
	}
	renderChevronIcon() {
		return o`
            <ptc-ui-icon
                name="icon.toggle.expand-active"
                class="pointer-events-none absolute top-1/2 right-2 h-4 w-4 -translate-y-1/2 text-gray-500"
            ></ptc-ui-icon>
        `;
	}
	render() {
		let e = !this.selectedOption, t = this.chevronStyle === "background" ? "background-image: url('data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 version=%271.1%27 height=%2710px%27 width=%2720px%27%3E%3Ctext x=%270%27 y=%2710%27 %3E%E2%96%BE%3C/text%3E%3C/svg%3E');" : "";
		return o`
            <div class="relative">
                ${this.label ? i(this.label) : s}
                <select
                    name="${this.name}"
                    ?disabled="${this.disabled}"
                    ?required="${this.required}"
                    @change="${this.handleSelectChange}"
                    class="${this.chevronStyle === "background" ? "bg-[length:1.5em_1em] bg-right bg-no-repeat" : ""} w-full cursor-pointer appearance-none rounded-md border border-gray-300 bg-white px-3 py-2 pr-8 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none disabled:cursor-not-allowed disabled:bg-gray-100"
                    style="${t}"
                >
                    ${e ? o`<option value="" selected disabled>${this.placeholder}</option>` : ""}
                    ${this.options.map((e) => o`
                            <option
                                value="${e.value}"
                                ?disabled="${e.disabled}"
                                ?selected="${this.selectedOption?.value === e.value}"
                            >
                                ${e.label}
                            </option>
                        `)}
                </select>
                ${this.chevronStyle === "icon" ? this.renderChevronIcon() : ""}
            </div>
        `;
	}
};
n([l({ type: Array }), t("design:type", Array)], d.prototype, "options", void 0), n([l({
	type: String,
	attribute: "placeholder"
}), t("design:type", Object)], d.prototype, "placeholder", void 0), n([l({
	type: String,
	attribute: "name"
}), t("design:type", Object)], d.prototype, "name", void 0), n([l({
	type: String,
	attribute: "label"
}), t("design:type", Object)], d.prototype, "label", void 0), n([l({ type: Boolean }), t("design:type", Object)], d.prototype, "disabled", void 0), n([l({ type: Boolean }), t("design:type", Object)], d.prototype, "required", void 0), n([l({ type: String }), t("design:type", String)], d.prototype, "chevronStyle", void 0), n([u(), t("design:type", Object)], d.prototype, "selectedOption", void 0), d = n([c("ptc-ui-select")], d);
//#endregion
export { d as Select };

//# sourceMappingURL=select.js.map